import { createContext, useState } from "react";

export const GruposContext = createContext();

export const GruposProvider = ({ children }) => {

    const [groups, setGroups] = useState([]); // Estado que armazena a lista de Grupos existentes
    const [products, setProducts] = useState([]); // Estado que armazena a lista de Produtos existentes
    const [editingGrupo, setEditingGrupo] = useState(null); // Estado que armazena se o usuário está editando um Grupo ou não
    const [groupName, setGroupName] = useState(""); // Estado que armazena o nome do Novo Grupo
    const [idsProductsSelected, setIdsProductsSelected] = useState([]); // Estado que armazena a lista dos IDs dos Produtos selecionados
    const [productSearched, setProductSearched] = useState(""); // Estado que armazena o nome do Produto pesquisado pelo usuário dentro do Modal Criar Novo Grupo
    const [isOpenModalCreateGroup, setIsOpenModalCreateGroup] = useState(false); // Estado que armazena se o Modal de Criar Novo Grupo está aberto ou não
    const [isOpenModalEditGroup, setIsOpenModalEditGroup] = useState(false); // Estado que armazena se o Modal de Editar Grupo está aberto ou não
    const [formDataModalEditGroup, setFormDataModalEditGroup] = useState({}); // Estado que armazena os dados do grupo que está sendo editado
    const [isOpenModalDeleteGroup, setIsOpenModalDeleteGroup] = useState(false); // Estado que armazena se o Modal de Deletar Grupo está aberto ou não
    const [formDataModalDeleteGroup, setFormDataModalDeleteGroup] = useState({}); // Estado que armazena os dados do grupo que está sendo deletado

    return (
        <GruposContext.Provider value={{
            groups, setGroups, products, setProducts, editingGrupo, setEditingGrupo, groupName, setGroupName, productSearched, setProductSearched,
            idsProductsSelected, setIdsProductsSelected, isOpenModalCreateGroup, setIsOpenModalCreateGroup, isOpenModalEditGroup, setIsOpenModalEditGroup,
            isOpenModalDeleteGroup, setIsOpenModalDeleteGroup, formDataModalEditGroup, setFormDataModalEditGroup, formDataModalDeleteGroup, setFormDataModalDeleteGroup
        }}>
            { children }
        </GruposContext.Provider >
    );
};
